"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = WazeAutoroute;
// components/WazeAutoroute.tsx
const react_1 = __importStar(require("react"));
const zones = [
    { name: "Dakar ↔ Diamniadio", lat: 14.72, lon: -17.35, zoom: 12 },
    { name: "Diamniadio ↔ AIBD", lat: 14.70, lon: -17.15, zoom: 12 },
    { name: "AIBD ↔ Thiès", lat: 14.76, lon: -17.00, zoom: 11 },
];
function WazeAutoroute() {
    const [activeZone, setActiveZone] = (0, react_1.useState)(zones[0]);
    const src = `https://embed.waze.com/iframe?zoom=${activeZone.zoom}&lat=${activeZone.lat}&lon=${activeZone.lon}`;
    const wazeUrl = `https://waze.com/ul?ll=${activeZone.lat},${activeZone.lon}&navigate=yes`;
    return (react_1.default.createElement("div", { style: { maxWidth: 1000, margin: "0 auto", textAlign: "center" } },
        react_1.default.createElement("h2", { style: { margin: "20px 0" } }, "\uD83D\uDE97 Trafic en direct \u2013 Autoroute A1 (Dakar \u2194 Thi\u00E8s)"),
        react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "15px",
            } }, zones.map((zone) => (react_1.default.createElement("button", { key: zone.name, onClick: () => setActiveZone(zone), style: {
                backgroundColor: zone.name === activeZone.name ? "#05C2F2" : "#E5E5E5",
                color: zone.name === activeZone.name ? "white" : "#333",
                padding: "10px 16px",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                transition: "0.2s",
            } }, zone.name)))),
        react_1.default.createElement("div", { style: {
                width: "100%",
                height: "600px",
                borderRadius: "12px",
                overflow: "hidden",
                position: "relative",
            } },
            react_1.default.createElement("iframe", { key: src, title: "Waze Autoroute A1", src: src, width: "100%", height: "100%", style: { border: 0 }, allowFullScreen: true })),
        react_1.default.createElement("div", { style: {
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                flexWrap: "wrap",
            } },
            react_1.default.createElement(Legend, { color: "#05C2F2", label: "Trajet principal A1" }),
            react_1.default.createElement(Legend, { color: "#00FF00", label: "Trafic fluide" }),
            react_1.default.createElement(Legend, { color: "#FFA500", label: "Ralentissement" }),
            react_1.default.createElement(Legend, { color: "#FF0000", label: "Bouchon / Accident" }),
            react_1.default.createElement(Legend, { color: "#808080", label: "Travaux / Fermeture" })),
        react_1.default.createElement("a", { href: wazeUrl, target: "_blank", rel: "noopener noreferrer", style: {
                display: "inline-block",
                marginTop: 20,
                padding: "10px 20px",
                background: "#05C2F2",
                color: "white",
                borderRadius: 8,
                textDecoration: "none",
            } }, "\uD83D\uDCCD Ouvrir dans Waze")));
}
function Legend({ color, label }) {
    return (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "6px" } },
        react_1.default.createElement("div", { style: {
                width: 20,
                height: 10,
                backgroundColor: color,
                borderRadius: 4,
                border: "1px solid #ccc",
            } }),
        react_1.default.createElement("span", { style: { fontSize: 14 } }, label)));
}
